import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/tree-view/simple-tree-view/selection/selection.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
